import { AppStore } from "redux/store"
import { PUBLIC_API } from "redux/api"
import jwtDecode from "jwt-decode"

import { login, logout } from "redux/features/auth/authSlice"
import { AuthPayloadType, JwtPayload } from "types"

class TokenService {
  getAuth = (store: AppStore) => {
    const state = store.getState()
    const { auth } = state
    const { id, accessToken, refreshToken } = auth

    return { id, accessToken, refreshToken }
  }
  setAuth = (store: AppStore, payload: AuthPayloadType) => {
    const { dispatch } = store

    dispatch(login(payload))
  }
  refresh = async (store: AppStore) => {
    const { dispatch } = store

    try {
      const { refreshToken } = this.getAuth(store)

      if (refreshToken) {
        const response = await PUBLIC_API.post("/access_refresh", {
          refresh_token: refreshToken,
        })
        const { authentication } = response.data
        const { id, access_token, refresh_token } = authentication
        const payload = {
          id: id,
          accessToken: access_token,
          refreshToken: refresh_token,
        }

        this.setAuth(store, payload)

        return payload
      } else {
        dispatch(logout())
      }
    } catch (error) {
      dispatch(logout())
    }
  }
  validate(accessToken: string) {
    const jwt = jwtDecode<JwtPayload>(accessToken)
    const exp = new Date(jwt.exp * 1000)

    return exp && new Date() < exp
  }
}

export default new TokenService()
